@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackScore {
  overflow: hidden;

  .image {
    width: 100%;
    position: relative;
    margin-bottom: 170px;

    .screen {
      width: 100%;
      border-radius: 16px;
    }

    .score {
      width: 21.1%;
      border-radius: 14px;
      position: absolute;
      right: 0;
    }
  }

  .case {
    border-radius: 22px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    background: linear-gradient(180deg, rgba(0, 229, 50, 0.00) 0%, rgba(0, 255, 55, 0.06) 100%);
    padding: 40px;

    .scoreIcon {
      align-items: center;
      margin-bottom: 140px;
      display: flex;
      justify-content: center;
      width: fit-content;

      .aiShadow {
        background: var(--web-green);
        filter: blur(40px);
        width: 100px;
        height: 100px;
        position: absolute;
      }

      .aiIcon {
        height: 115px;
        width: 115px;
        position: relative;

        @include icons.ico("colored-speedometer");
      }
    }

    .text {
      font-size: 34px;
      width: calc(80% - 75px);
      max-width: 650px;

      @include texts.font("semi-bold");
    }

    .scoreMobileContainer {
      overflow: hidden;
      max-height: 310px;
      display: none;
      position: relative;
      top: 15px;

      .scoreMobile {
        width: 100%;
        border-radius: 14px 14px 0px 0px;
      }
    }
  }

  @media screen and (max-width: 930px) {
    overflow: visible !important;

    .case {
      padding: 15px !important;
    }
    .image {
      margin-bottom: 20px !important;
      margin-left: -100% !important;
      width: 200% !important;
    }

    .screen {
      border-radius: 4px !important;
    }

    .scoreMobileContainer {
      display: block !important;
    }

    .scoreIcon {
      margin-bottom: 20px !important;

      .aiIcon {
        width: 60px !important;
        height: 60px !important;
      }

      .aiShadow {
        filter: blur(25px);
        width: 40px;
        height: 40px;
      }
    }

    .text {
      width: 100% !important;
      font-size: 22px !important;
    }
  }
}